module.exports = __webpack_public_path__ + "img/banner_768x2.7c03e946.webp";